import React from 'react';

import { Box } from '../Box/Box';
import { Typography } from '../Typography/Typography';

interface ControlHeaderProps {
  header: string;
  controls?: React.ReactElement;
}

export const ControlHeader = (props: ControlHeaderProps): React.ReactElement => {
  const { header, controls } = props;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        padding: 1,
        paddingBottom: 0
      }}>
      <Typography variant='h3' text={header} sx={{ width: '75%', padding: 1 }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexWrap: 'nowrap',
          flexDirection: 'row',
          width: '25%'
        }}>
        {controls || <></>}
      </Box>
    </Box>
  );
};
